<template>
  <div class="available-labour-sundry quote-builder-add-items">
    <!-- Add your template content here -->

    <div class="fixed-grid">
      <div class="grid">

        <div class="cell">
          <div class="field has-addons">
            <div class="control has-icons-left has-icons-right">
              <input class="input"
                v-model="searchValue"
                type="text"
                placeholder="Start typing to filter"
                @input="search">
              <span class="icon is-left">
                <i class="mdi mdi-magnify mdi-18px" />
              </span>
            </div>
            <div class="control">
              <a class="button is-primary is-outlined tooltip"
                data-tooltip="Reset search"
                @click="reset()">
                <span class="icon">
                  <i class="mdi mdi-close mdi-24px" />
                </span>
              </a>
            </div>
          </div>
        </div>

        <div class="cell" />

      </div>
    </div>

    <div class="table-container-avaialble-butterfly-items pr-1">
      <div class="fixed-grid has-12-cols mb-2 has-background-white"
        style="position: sticky; top: 0px; z-index: 10; border-bottom: 1px solid grey;">
        <div class="grid ">

          <div class="cell is-col-span-8">Item Name</div>

          <div class="cell is-col-span-4">
            <div class="fixed-grid has-12-cols">
              <div class="grid">
                <div class="cell is-col-span-6 has-text-center">R&R (H)s</div>
                <!-- <div class="cell is-col-span-4 has-text-center">REP</div> -->
                <div class="cell is-col-span-6 has-text-center">Paint (H)s</div>
              </div>
            </div>
          </div>

        </div>
      </div>

      <div class="fixed-grid has-12-cols">
        <div v-for="(item, index) in availableItems"
          :key="index"
          class="grid my-2 p-1"
          :class="{ 'has-background-light': index % 2 !== 0 }">
          <div class="cell is-col-span-8 has-overflow-ellipsis"
            @dblclick="addNewItems(item, index)"
            style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; "
            v-tippy="{ content: item.itemName, placement: 'top' }">
            {{ item.itemName }}
          </div>

          <div class="cell is-col-span-4">
            <div class="fixed-grid has-12-cols">
              <div class="grid">

                <div class="cell is-col-span-6 has-text-center"
                  @click="addSingleNewItem(item, itemCategoryTypes.RR, true)">
                  <div class="butterfly-item-values is-flex is-justify-content-center"
                    :class="{ ' has-text-weight-bold is-selected': findItem(item, itemCategoryTypes.RR) }">
                    {{ $filters.formatNumber(item.maximumTimeAllowance, $userInfo.locale, 0) }}
                  </div>
                </div>
                <!-- <div class="cell is-col-span-4 has-text-center disabled"
                  @click="addSingleNewItem(item, itemCategoryTypes.REP, true)">
                  <div class="butterfly-item-values is-flex is-justify-content-center"
                    :class="{ ' has-text-weight-bold is-selected': findItem(item, itemCategoryTypes.REP) }">
                    {{ $filters.formatNumber(0, $userInfo.locale, 0) }}
                  </div>
                </div> -->
                <div class="cell is-col-span-6 has-text-center"
                  @click="addSingleNewItem(item, itemCategoryTypes.PAINT, true)">
                  <div class="butterfly-item-values is-flex is-justify-content-center"
                    :class="{ ' has-text-weight-bold is-selected': findItem(item, itemCategoryTypes.PAINT) }">
                    {{ $filters.formatNumber(getPaintRateVehicleLayerGroup(item), $userInfo.locale, 0) }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="availableItems.length === 0 && !isLoadingData"
        class="grid-empty">
        <section class="section">
          <div class="content has-text-grey has-text-centered">
            <span icon="icon is-large">
              <i class="mdi mdi-48px mdi-emoticon-sad" />
            </span>
            <p>Nothing</p>
          </div>
        </section>
      </div>

      <div v-if="isLoadingData"
        class="grid-empty">
        <section class="section">
          <div class="content has-text-grey has-text-centered">
            <span icon="icon is-large">
              <i class="mdi mdi-50px mdi-48
              px mdi-loading mdi-spin" />
            </span>
          </div>
        </section>
      </div>

    </div>
  </div>
</template>

<script>
import QuoteService from '../../../QuoteService'
// import BulmaTable from '../../../../../components/BulmaTable/BulmaTable.vue'
import { ItemCategoryTypes, QuotingMethodTypes } from '@/enums'
import debounce from 'lodash/debounce'
import { AvailableLabourColumns } from '../../../columns'
import { QuoteItemModel } from '@/classes/viewmodels'
import { roundAwayFromZero } from '@/components/utils/AccountingFunctions'

export default {
  name: 'AvailableLabourSundry',
  components: {
    // BulmaTable
  },
  props: {
    value: {
      type: Array,
      default: () => []
    },
    shopRate: {
      type: Number,
      default: 0
    },
    paintRate: {
      type: Number,
      default: 0
    },
    nextLineNumber: {
      type: Number,
      default: 0
    },
    vehiclePaintGroup: {
      type: String,
      default: ''
    },
    quotingMethod: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      isLoadingData: false,
      availableItems: [],
      searchValue: '',
      addedItems: []
    }
  },
  computed: {
    itemCategoryTypes() {
      return ItemCategoryTypes
    },
    columns() {
      return AvailableLabourColumns
    },
    maxAddedItemsLineNumber() {
      return Math.max(...this.addedItems.map((a) => a.lineNumber), 0)
    }
  },
  mounted() {
    this.getAvailableLabourSundry()
  },
  methods: {
    search: debounce(function () {
      // Add your method logic here
      this.getAvailableLabourSundry()
    }, 200),
    sort(name, order) {},
    async getAvailableLabourSundry() {
      this.isLoadingData = true
      // Add your method logic here
      let search = this.searchValue
      let quoteService = await QuoteService.getAvailableLabourSundry(search)
      this.availableItems = quoteService
      this.isLoadingData = false
    },
    getPaintRateVehicleLayerGroup(item) {
      // Add your method logic here
      if (this.vehiclePaintGroup !== '') {
        const paintGroupMapping = {
          M1: item.maximumLayer1Allowance,
          M2: item.maximumLayer2Allowance,
          M3: item.maximumLayer3Allowance,
          S1: item.maximumLayer1Allowance,
          S2: item.maximumLayer2Allowance,
          S3: item.maximumLayer3Allowance
        }
        return paintGroupMapping[this.vehiclePaintGroup] || 0
      }
      return 0
    },
    addSingleNewItem(item, type, emit = false, bulkAdd = false) {
      let hour = 0
      let rate = 0
      switch (type) {
        case ItemCategoryTypes.RR:
          hour = item.maximumTimeAllowance
          rate = this.shopRate
          break

        case ItemCategoryTypes.PAINT:
          hour = this.getPaintRateVehicleLayerGroup(item)
          rate = this.shopRate
          break
      }
      const existingItem = this.findItem(item, type)

      if (!existingItem) {
        const newItem = this.generateItem(item.labourID, item.itemName, hour, rate, type)
        this.addedItems.splice(this.addedItems.length, 1, newItem)
        if (emit) {
          // this.innerValue.splice(this.innerValue.length, 1, newItem)
          this.$emit('item-added', this.addedItems)
          this.addedItems = []
        }
      } else {
        if (!bulkAdd) {
          this.$eventHub.$emit('deleteLabour', existingItem)
        } else this.$notification.openNotificationWithType('warning', 'Labour', `${type} item is already in selected list. Item not added.`)
      }
    },
    generateItem(itemNo, description, hourValue, rate, type) {
      let newItem = new QuoteItemModel(this.quoteId, itemNo, description, type)
      newItem.lineNumber = Math.max(this.maxAddedItemsLineNumber + 1, this.nextLineNumber)
      newItem.hourValue = this.quotingMethod === QuotingMethodTypes.Hour ? hourValue : roundAwayFromZero(hourValue * rate)
      newItem.rate = rate
      newItem.dollarValue = roundAwayFromZero(hourValue * rate)
      newItem.opgCode = this.vehiclePaintGroup
      newItem.sortNo = this.value.length ? Math.max(...this.value.map((i) => i.sortNo)) + 1 : 1
      return newItem
    },
    findItem(item, itemCategory) {
      const itemFound = this.value.find((i) => i.itemNo == item.labourID && i.itemType === itemCategory && i.itemDesc === item.itemName)
      // Add your method logic here
      return itemFound
    }
  }
}
</script>

<style scoped>
.available-labour-sundry {
  /* Add your component styles here */
}
</style>